package de.xtl.retroguide

import de.xtl.retroguide.protocol.RadarAnswer
import de.xtl.retroguide.protocol.RadarDimension
import de.xtl.retroguide.protocol.VisibleAnswer
import de.xtl.retroguide.protocol.toRadarAnswer

internal data class RadarStats(
    val averages: Map<RadarDimension, Double>,
    val answers: List<Pair<String, RadarAnswer>>,
)

/** Only complete radar answers count; returns null when there is none. */
internal fun List<VisibleAnswer>.radarStats(): RadarStats? {
    val answers = mapNotNull { answer ->
        answer.content.toRadarAnswer()?.takeIf { it.isComplete }?.let { answer.participantName to it }
    }
    if (answers.isEmpty()) return null
    return RadarStats(
        averages = RadarDimension.entries.associateWith { dimension ->
            answers.map { (_, radar) -> radar.scores.getValue(dimension) }.average()
        },
        answers = answers,
    )
}
